import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { NavProfileIcon, QuickValuationIcon, VehicleIcon } from '../../../assets';
import { useNotificationContext } from '../../../contexts/NotificationContext';
import {
  Container,
  DotContainer,
  Line,
  Link,
  NotificationIconContainer,
  StyledBellRouteIcon,
  UnreadDotIndicator,
} from './BottomNav.styles';

export const BOTTOM_BAR_ELEMENT_ID = 'bottom-navigation-bar';

interface LinkType {
  titleKey: string;
  path: string;
  icon: ReactNode;
}

const BottomNav = () => {
  const { t } = useTranslation();
  const { unreadCount } = useNotificationContext();

  const renderIconWithDot = (icon: ReactNode, showDot: boolean) => {
    return (
      <NotificationIconContainer>
        {icon}
        {showDot && (
          <DotContainer>
            <UnreadDotIndicator />
          </DotContainer>
        )}
      </NotificationIconContainer>
    );
  };

  const links: LinkType[] = [
    { titleKey: 'listings.title', path: '/app/listings', icon: <VehicleIcon /> },
    // TODO: General chat will remain hidden for now.
    // { titleKey: 'Chat', path: '/app/chat', icon: renderIconWithDot(<StyledChatWriteIcon />, unreadTotalCount > 0) },
    {
      titleKey: 'Notifications',
      path: '/app/notifications',
      icon: renderIconWithDot(<StyledBellRouteIcon />, unreadCount > 0),
    },
    { titleKey: 'profile.myAccount', path: '/app/settings/profile', icon: <NavProfileIcon /> },
  ];

  if (process.env.REACT_APP_QUICK_VALUATION_FEATURE_FLAG === 'true') {
    links.splice(1, 0, {
      titleKey: 'createVehicle.quickValuation',
      path: '/app/quickValuation',
      icon: <QuickValuationIcon />,
    });
  }

  return (
    <Container id={BOTTOM_BAR_ELEMENT_ID}>
      {links.map((link) => {
        return (
          <Link key={link.titleKey} to={link.path}>
            <>
              {link.icon}
              {t(link.titleKey)}
            </>
          </Link>
        );
      })}
      <Line />
    </Container>
  );
};

export default BottomNav;
